// Logos en varias resoluciones: el navegador elige la nítida según el tamaño y la pantalla.
export const LOGO = '/logo.png?v=3';
export const LOGO_SRCSET = '/logo-160.webp 160w, /logo-320.webp 320w, /logo.png?v=3 512w, /logo-1024.webp 1024w';

export const DELIVERY = '/cupido-delivery.png';
export const DESCUENTOS = '/cupido-descuentos.png';
export const DESCUENTOS_SRCSET = '/cupido-descuentos-160.webp 160w, /cupido-descuentos-320.webp 320w, /cupido-descuentos.png 512w, /cupido-descuentos-640.webp 640w';

export const DELIVERY_SRCSET = '/cupido-delivery-320.webp 320w, /cupido-delivery-640.webp 640w, /cupido-delivery-960.webp 960w';
